import { UserManagerSettings } from 'oidc-client-ts';

import { AZURE_CLIENT_ID, AZURE_TENANT_ID, CIAM_CLIENT_ID } from './index';

export const OidcProvider = {
  AZURE: 'azure',
  CIAM: 'ciam'
} as const;

export type OidcProvider = (typeof OidcProvider)[keyof typeof OidcProvider];

// Azure AD OIDC Configuration
export const azureOidcConfig: UserManagerSettings = {
  authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}/v2.0`,
  client_id: AZURE_CLIENT_ID,
  redirect_uri: `${window.location.origin}/public/oauth`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: false, // Disable auto-renewal to prevent silent login
  filterProtocolClaims: true,
  loadUserInfo: false // Use id_token claims instead
};

// WFP CIAM OIDC Configuration
export const ciamOidcConfig: UserManagerSettings = {
  authority: 'https://ciam.auth.wfp.org',
  client_id: CIAM_CLIENT_ID,
  redirect_uri: `${window.location.origin}/public/coauth`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email phone',
  automaticSilentRenew: false,
  filterProtocolClaims: true,
  loadUserInfo: false,
  metadata: {
    issuer: 'https://ciam.auth.wfp.org/oauth2/token',
    authorization_endpoint: 'https://ciam.auth.wfp.org/oauth2/authorize',
    token_endpoint: 'https://ciam.auth.wfp.org/oauth2/token',
    userinfo_endpoint: 'https://ciam.auth.wfp.org/oauth2/userinfo',
    jwks_uri: 'https://ciam.auth.wfp.org/oauth2/jwks'
  }
};

// Get config by provider
export const getOidcConfig = (provider: OidcProvider): UserManagerSettings => {
  switch (provider) {
    case OidcProvider.AZURE:
      return azureOidcConfig;
    case OidcProvider.CIAM:
      return ciamOidcConfig;
    default:
      throw new Error(`Unknown OIDC provider: ${provider}`);
  }
};
